const LoginBanner = () => {
  return (
    <div className=" hidden lg:block min-h-full w-[60%] shrink-0 login-left">
      <div
        className="img-block w-full relative"
        style={{ height: 'calc(100vh - 32px)' }}
      >
        <img
          src="/images/login-banner.png"
          className="w-full object-cover h-full rounded-[24px]"
          alt="login banner"
        />
        {/* <div className="banner-logo absolute top-6 left-13 z10 max-w-[140px] 2xl:max-w-[280px]">
          <img src="/images/app_logo.png" className="w-full" alt="logo-image" />
        </div>
        <div className="banner-content 2xl:max-w-[360px] max-w-[280px] absolute top-14 right-14 z-10">
          <h1 className="text-[38px] 2xl:text-[52px] font-light leading-none">
            Empower your <br /> Business with
            <span className="text-[60px] 2xl:text-[62px] font-bold uppercase leading-[1] block my-2 2xl:my-3">
              Hiremore
            </span>
          </h1>
          <p className="text-md 2xl:text-lg">
            Streamline your schedule, and collaborate with fellow professionals.
          </p>
        </div> */}
      </div>
    </div>
  )
}

export default LoginBanner
